export const ARTICLE_TEST_IDS = {
    HEADLINES: {
        HOMEPAGE: "blog-homepage-headline-category-name",
        CATEGORY_NAME: "blog-headline-category-name",
        FEATURED: "blog-headline-featured",
        NEWEST: "blog-headline-newest"
    },
    ARTICLE_LIST: {
        ARTICLE_BOX: "blog-article-list-box",
        FEATURED_ARTICLE_BOX: "blog-featured-article-list-box"
    }
};
